module.exports = __webpack_public_path__ + "img/Slice2.53f39b17.png";